import React, { useState } from 'react';
import Breadcrumb from '../../components/breadcrumb';
import UQCheckbox from '../../components/checkbox';
import UQSpacer from '../../components/spacer';
import UQCode from '../../components/code';
import UQDataGrid, { UQDataGridColumn } from '../../components/data-grid';
import { BREADCRUMB_ROOT } from '../../common/config';

const attributes = [
  { attribute: 'checked', type: 'boolean', default: 'false', description: 'Whether the checkbox is checked.' },
  { attribute: 'onChange', type: '(checked: boolean) => void', default: 'undefined', description: 'Callback when the checked state changes.' },
  { attribute: 'label', type: 'string', default: "''", description: 'Label for the checkbox.' },
  { attribute: 'disabled', type: 'boolean', default: 'false', description: 'Disable the checkbox.' },
  { attribute: 'className', type: 'string', default: "''", description: 'Additional class names.' },
  { attribute: 'style', type: 'React.CSSProperties', default: 'undefined', description: 'Inline styles.' },
];

const attributeColumns: UQDataGridColumn<typeof attributes[0]>[] = [
  { columnId: 'attribute', renderHeaderCell: () => 'Attribute', renderCell: (item) => item.attribute },
  { columnId: 'type', renderHeaderCell: () => 'Type', renderCell: (item) => <code>{item.type}</code> },
  { columnId: 'default', renderHeaderCell: () => 'Default', renderCell: (item) => <code>{item.default}</code> },
  { columnId: 'description', renderHeaderCell: () => 'Description', renderCell: (item) => item.description },
];

const codeExample = `
const [checked, setChecked] = useState(false);

  return (
    <>
      <h2>Examples</h2>
      <UQSpacer size="s" />
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <UQCheckbox label="Default" />
        <UQCheckbox label="Checked" checked />
        <UQCheckbox label="Disabled" disabled />
        <UQCheckbox
          label="Controlled"
          checked={checked}
          onChange={setChecked}
        />
      </div>
      <UQSpacer size="m" />
      <h2>Code Example</h2>
      <UQCode code={codeExample.trim()} enableCopy />
    </>
  );
`;

const CheckboxDemoPage = () => {
  const [checked, setChecked] = useState(false);

  return (
    <>
      <Breadcrumb crumbs={[BREADCRUMB_ROOT, 'Checkbox']} />
      <h1>UQCheckbox Demo</h1>
      <UQSpacer size="m" />

      <h2>Description</h2>
      <p>
        <code>UQCheckbox</code> is a customizable checkbox component with support for labels, controlled/uncontrolled state, and disabled mode.
      </p>
      <UQSpacer size="m" />

      <h2>Attributes</h2>
      <UQSpacer size="s" />
      <UQDataGrid
        items={attributes}
        columns={attributeColumns}
        sortable={false}
        selectionMode="none"
        rowLines
      />
      <UQSpacer size="m" />

      <h2>Examples</h2>
      <UQSpacer size="s" />
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <UQCheckbox label="Default" />
        <UQCheckbox label="Checked" checked />
        <UQCheckbox label="Disabled" disabled />
        <UQCheckbox
          label="Controlled"
          checked={checked}
          onChange={setChecked}
        />
      </div>
      <UQSpacer size="m" />

      <h2>Code Example</h2>
      <UQCode code={codeExample.trim()} enableCopy />
    </>
  );
};

export default CheckboxDemoPage;